import { defineNuxtRouteMiddleware } from 'nuxt/app'
import { safeJSONParse } from '../utility/json'
import { logger } from '../utility/logger'

export default defineNuxtRouteMiddleware((to) => {
  if (process.server && to.query.bounds) {
    const { path, query, hash } = to
    const bounds = safeJSONParse(query.bounds as string)

    // If bounds are in old format, convert them
    if (bounds && isOldBoundsFormat(bounds)) {
      const { north, south, east, west } = bounds
      const redirectQuery = {
        ...query,
        bounds: JSON.stringify({
          northEast: { lat: north, lng: east },
          southWest: { lat: south, lng: west },
        }),
      }
      return navigateTo(
        { path, query: redirectQuery, hash },
        { redirectCode: 301 },
      )
    }

    // If bounds param exists but is invalid/incomplete, remove it
    if (!isValidBounds(bounds)) {
      logger('updateBoundsParams.global: invalid bounds', query.bounds)
      const redirectQuery = { ...query }
      delete redirectQuery.bounds
      return navigateTo(
        { path, query: redirectQuery, hash },
        { redirectCode: 301 },
      )
    }
  }
})

function isOldBoundsFormat(bounds: unknown): bounds is Record<string, number> {
  if (typeof bounds !== 'object' || bounds === null) {
    return false
  }
  const { north, south, east, west } = bounds as Record<string, any>
  return (
    typeof north === 'number' &&
    typeof south === 'number' &&
    typeof east === 'number' &&
    typeof west === 'number'
  )
}

interface LatLng {
  lat: number
  lng: number
}

interface ValidBounds {
  northEast: LatLng
  southWest: LatLng
}

function isValidBounds(bounds: unknown): bounds is ValidBounds {
  if (typeof bounds !== 'object' || bounds === null) {
    return false
  }
  const boundsObj = bounds as Record<string, unknown>
  const northEast = boundsObj.northEast
  const southWest = boundsObj.southWest
  if (
    typeof northEast !== 'object' ||
    northEast === null ||
    typeof southWest !== 'object' ||
    southWest === null
  ) {
    return false
  }
  const ne = northEast as Record<string, unknown>
  const sw = southWest as Record<string, unknown>
  return (
    typeof ne.lat === 'number' &&
    typeof ne.lng === 'number' &&
    typeof sw.lat === 'number' &&
    typeof sw.lng === 'number'
  )
}
